export default __webpack_public_path__ + "static/media/TTD2.eedeeee6.png";